import { useTranslation } from "react-i18next";
import { Button, Stack } from "~/common/mui";

interface StepperActionsProps {
  activeStep: number;
  isSkippable: boolean;
  handleBack: () => void;
  handleNext: () => void;
  canContinue: boolean;
}

export const StepperActions = ({
  activeStep,
  isSkippable,
  handleBack,
  handleNext,
  canContinue,
}: StepperActionsProps) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" justifyContent="space-between" mb={"140px"}>
      {activeStep !== 0 && (
        <Button variant="text" onClick={handleBack}>
          {t("onboarding.overlay.back.btn")}
        </Button>
      )}

      <Stack direction="row" gap={1} ml="auto">
        {isSkippable && (
          <Button variant="text" onClick={handleNext}>
            {t("onboarding.overlay.skip.btn")}
          </Button>
        )}

        <Button variant="contained" onClick={handleNext} disabled={!canContinue}>
          {t("onboarding.overlay.continue.btn")}
        </Button>
      </Stack>
    </Stack>
  );
};
